<template>
  <b-form-group
    label="Durum"
    label-for="id_purchase_offer_status"
  >
    <validation-provider
      #default="{ errors }"
      name="Durum"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_purchase_offer_status"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
        :disabled="dataItem.id_purchase_offer_status === '7' || dataItem.id_confirmed_user !== null"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PurchaseOfferStatusSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['purchaseOfferStatus/dataList']
    },
    dataItem() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('purchaseOfferStatus/getDataList', {
        select: [
          'purchase_offer_status.id AS id',
          'purchase_offer_status.title AS title',
        ],
      })
    },
  },
}
</script>
